import { render } from "./[vendorId].vue?vue&type=template&id=69034cb5&scoped=true"
import script from "./[vendorId].vue?vue&type=script&lang=js"
export * from "./[vendorId].vue?vue&type=script&lang=js"

import "./[vendorId].vue?vue&type=style&index=0&id=69034cb5&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69034cb5"]])

export default __exports__